require('tui-image-editor');

/**
 * Shows an image editor.
 * @param {string} src
 * @param {function} saved
 * @returns {ImageEditor}
 */
export function showImageEditor(src, saved)
{
	let editor = new ImageEditor(document.getElementById('tui-image-editor'),
	{
		usageStatistics: false,
		includeUI: {
			loadImage: {
				path: src,
				name: 'SampleImage',
			},
			initMenu: 'filter',
			menuBarPosition: 'bottom',
			theme: {
				'common.bi.image': '/images/tui-image-editor-logo.png'
			}
		},
		cssMaxWidth: window.outerWidth - 30,
		cssMaxHeight: window.outerHeight - 300,
		selectionStyle: {
			cornerSize: 20,
			rotatingPointOffset: 70,
		}
	});

	let tui = $('#tui-image-editor');
	tui.find('.tui-image-editor-load-btn').parent().remove();
	let downloadButton = tui.find('.tui-image-editor-download-btn:visible')
		.text('Save')
		.css({
			fontWeight: 'normal',
			color: 'black',
			fontSize: '1em'
		});

	/** @type HTMLButtonElement */
	let button = downloadButton.get(0);
	let saveButton = button.cloneNode(true);
	let cancelButton = button.cloneNode(true);
	cancelButton.innerText = 'Cancel';
	cancelButton.style.backgroundColor = 'white';

	button.parentElement.appendChild(cancelButton);
	button.parentElement.appendChild(saveButton);
	button.remove();

	if (saved)
	{
		saved = (function(saved, imageEditor)
		{
			return function(editor)
			{
				saved(editor);
				imageEditor.destroy();
				let elem = document.getElementById('tui-image-editor');
				elem.removeAttribute('class');
				elem.removeAttribute('style');
			};
		})(saved, editor);

		cancelButton.addEventListener('click', (function(saved)
		{
			return function() { saved(); }
		})(saved));

		saveButton.addEventListener('click', (function(saved, editor)
		{
			return function() { saved(editor); }
		})(saved, editor));
	}

	window.currentImageEditor = editor;
	return editor;
}

window.showImageEditor = showImageEditor;
